module.exports = __webpack_public_path__ + "static/img/icon_shopping-white.66fea54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_shopping-white.png
// module id = RerE
// module chunks = 1